import useTranslation from "next-translate/useTranslation";
import productWorkflowsImg from "/public/reactFlow/workflows/Product-Workflow.png";
import {
  CircleCancelMajor,
  DeleteMajor,
  DraftOrdersMajor, EnvelopeMajor,
  ExistingInventoryMajor, FolderMinusMajor, OrdersMajor,
  PaymentsMajor
} from "@shopify/polaris-icons";
import InfoTabTemplate from "../../../../common/components/InfoTab";
import {Product_Workflows} from "../index";
import {REACT_FLOW_LINK, RF_APP_LINK} from "../../../../../utils/constants";
import {RF_NAMESPACE} from "../../../../../utils/i18nNameSpaces";

const ProductWorkflow = ({}) => {
  const {t} = useTranslation(RF_NAMESPACE);
  const tempData = {
    header: t(`infoTabs.${Product_Workflows}.header`),
    subheader: t(`infoTabs.${Product_Workflows}.subheader`),
    dataList: [
      t(`infoTabs.${Product_Workflows}._1`),
      t(`infoTabs.${Product_Workflows}._2`),
      t(`infoTabs.${Product_Workflows}._3`),
      t(`infoTabs.${Product_Workflows}._4`),
      t(`infoTabs.${Product_Workflows}._5`),
      t(`infoTabs.${Product_Workflows}._6`),
      t(`infoTabs.${Product_Workflows}._7`),
      t(`infoTabs.${Product_Workflows}._8`),
    ],
    iconsList: [
      DraftOrdersMajor,
      DeleteMajor,
      CircleCancelMajor,
      ExistingInventoryMajor,
      PaymentsMajor,
      OrdersMajor,
      FolderMinusMajor,
      EnvelopeMajor,
    ],
    link: {
      text: t(`infoTabs.${Product_Workflows}.link.text`),
    }
  }

  return (
    <div>
      <InfoTabTemplate tempData={tempData} img={productWorkflowsImg} link={RF_APP_LINK}/>
    </div>
  );
};

export default ProductWorkflow;